import React from 'react';
import PropTypes from 'prop-types';

import { LOGO_ROOT, LARGE_LOGO_ROOT } from '../../constants';

import { getMerchantCardUrl } from '../../services/partner/utils';

import LocalizedNavLink from '../router/LocalizedNavLink';

class LogoPartenaireComponent extends React.Component {
    render() {
        const { partenaire, small, title, cssClass, url } = this.props;
        const urlFicheMarchand = getMerchantCardUrl(partenaire);
        const rootSrc = small ? LOGO_ROOT : LARGE_LOGO_ROOT;
        const fileName = partenaire.logo || `logo-${partenaire.ebcId}.gif`;
        const logo = (
            <img
                src={`${rootSrc}/${fileName}`}
                alt={partenaire.name}
                width={small ? '90' : '189'}
                height={small ? '50' : '91'}
                className={`partnerLogo ${cssClass ? cssClass : ''}`}
            />
        );

        return !url ? (
            logo
        ) : (
            <LocalizedNavLink
                to={url ? url : partenaire && urlFicheMarchand ? urlFicheMarchand : ''}
                title={title ? title : ''}
                className={cssClass ? cssClass : ''}
                name="partnerLogo-toMerchantCard">
                {logo}
            </LocalizedNavLink>
        );
    }
}

LogoPartenaireComponent.propTypes = {
    partenaire: PropTypes.object.isRequired,
    url: PropTypes.string,
    title: PropTypes.string,
    small: PropTypes.bool,
    cssClass: PropTypes.string
};

export default LogoPartenaireComponent;



// WEBPACK FOOTER //
// ./src/components/partner/LogoPartenaireComponent.js